var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTrivia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 365.2 46.8",
    style: {
      enableBackground: "new 0 0 365.2 103.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FCF9F5;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.2,37.8V16.3h-7v-3.4h18.3v3.4h-7v21.4H133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.4,37.8V12.9h8.2c5.4,0,9.2,2.2,9.2,7.2v0.1c0,1.9-0.6,3.5-1.6,4.6c-1.1,1.1-2.4,1.8-4,2.2l7.1,10.8h-4.7 l-6.7-10.2h-3.2v10.2H148.4z M152.7,24.5h3.9c3.2,0,4.9-1.3,4.9-4.1v-0.1c0-2.9-1.8-4-4.9-4h-3.9V24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.2,37.8V12.9h4.3v24.9H171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.8,37.8l-8.4-24.9h4.5l6.7,20.5l6.7-20.5h4.1l-8.5,24.9H187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.1,37.8V12.9h4.3v24.9H205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.6,37.8l8.4-24.9h5.6l8.2,24.9h-4.4l-2.1-6.4h-9.7l-2.1,6.4H213.6z M224.5,16.5l-3.8,11.8h7.6L224.5,16.5 z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrivia);
export default __webpack_public_path__ + "static/media/logo-trivia.eed149125192af23de21312130c342ed.svg";
export { ForwardRef as ReactComponent };